import { IRootState } from "../../../redux/root.reducer";

export const ITEMS_PER_PAGE_ALL = -1;
const MAX_ITEMS_LIMIT = 10000;

export const selectFiltersAndPagination = (state: IRootState) => {
    const limit = state.dataBrowserList.pagination.itemsPerPage;

    return {
        ...state.dataBrowserList.filters,
        limit: limit === ITEMS_PER_PAGE_ALL ? MAX_ITEMS_LIMIT : limit,
        offset:
            limit === ITEMS_PER_PAGE_ALL
                ? 0
                : (state.dataBrowserList.pagination.currentPage - 1) * limit,
        sortField: state.dataBrowserList.sorting.column,
        sortDirection: state.dataBrowserList.sorting.order,
    };
};

export const selectExportFiltersAndPagination = (state: IRootState) => ({
    ...state.dataBrowserList.filters,
    limit: state.dataBrowserList.lists?.total ?? 0,
    offset: 0,
    columns: state.dataBrowserList.columns,
});
